<template>
	<div>
		<div class="condition">
			<div class="search_wrap">
				<el-form :inline="true"  :model="formdata" class="form-inline">
				<el-form-item label="提现状态">
					<el-select v-model="value" placeholder="请选择" class="w130" size="small" @change="getStatus">
						<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
					<!-- <el-input v-model="value" placeholder="请选择" class="w80" size="medium"></el-input> -->
				</el-form-item>
				<el-form-item label="创建时间">
					<el-date-picker
						v-model="timeData"
						type="daterange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						size="small"
						format="yyyy-MM-dd"
						value-format="yyyy-MM-dd"
						:picker-options="pickerOptions1">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary"  size="small" @click="searchcustomer">搜索</el-button>
				</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="table_wrap">
			<el-table :data="tableData" style="width: 100%">
				<!-- <el-table-column prop="id" label="编号"></el-table-column>
				<el-table-column prop="openid" label="openid"></el-table-column> -->
				<!-- <el-table-column prop="nickname" label="微信昵称"></el-table-column> -->
				<el-table-column label="收款人" align="center">
				<template slot-scope="scope">
					<img :src="scope.row.avatar" alt width="60px" height="60px" v-if="scope.row.avatar"/>
					<img src="@/assets/imgs/userDefult.png" alt width="60px" height="60px" v-else/>
					<p>{{scope.row.nickname}}</p>
				</template>
				</el-table-column>
				<el-table-column prop="withdraw_method" label="提现方式"></el-table-column>
				<el-table-column prop="amount" label="提现金额"></el-table-column>
				<el-table-column prop="amount_real" label="实际到账金额"></el-table-column>
				<el-table-column prop="amount_fee" label="提现手续费">
					<div slot-scope="scope" >
						<p>{{scope.row.amount_fee.split(";")[0]}}</p>
						<p>{{scope.row.amount_fee.split(";")[1]}}</p>
					</div>
				</el-table-column>
				<el-table-column  label="提现信息">
					<template slot-scope="scope">
						<p>{{scope.row.user_name}}</p>
						<p>{{scope.row.id_card}}</p>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="id_card" label="身份证号码"></el-table-column> -->
				<el-table-column prop="status_text" label="提现状态">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 1" :class="{required: scope.row.status == 1}">{{scope.row.status_text}}</span>
						<span v-else-if="scope.row.status == 2" :class="{red: scope.row.status == 2}">{{scope.row.status_text}}</span>
						<span v-else>{{scope.row.status_text}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="create_time" label="创建时间">
					<div slot-scope="scope" >
						<span>{{scope.row.create_time.split(" ")[0]}}</span>
						<br>
						<span>{{scope.row.create_time.split(" ")[1]}}</span>
					</div>
				</el-table-column>							
				<el-table-column prop="do_time_text" label="处理时间">
					<div slot-scope="scope" >
						<span>{{scope.row.do_time_text.split(" ")[0]}}</span>
						<br>
						<span>{{scope.row.do_time_text.split(" ")[1]}}</span>
					</div>
				</el-table-column>
				<el-table-column prop="reasons" label="处理结果">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 1" :class="{required: scope.row.status == 1}">{{scope.row.reasons}}</span>
						<span v-else>{{scope.row.reasons}}</span>
					</template>
				</el-table-column>
			</el-table>
			<div class="pag_wrap">
				<el-pagination
					background
					:page-size="page.page_size"
					:current-page="page.current_page"
					layout="total, prev, pager, next"
					:total="page.total_rows"
					@current-change="pageIndexChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
	import api from "@/api.js";
	import { pagination1 } from "@/util/util.js";
	export default {
		name: 'accountWdrawalList',
		data() {
		  return {
				options: [
					{
						value: 0,
						label: '全部'
					},
					{
						value: 1,
						label: '待处理'
					},
					{
						value: 2,
						label: '已处理'
					},
					{
						value: 3,
						label: '已驳回'
					},
				],
				value: '',
		    formdata: {
		      page: 1,   //	整型 	必填 	- 	- 	页码
		      start_time: '',
					end_time: '',
					status: ''
		    },
		    timeData: [],
		    tableData: [],
				page: {
					current_page: pagination1.current_page, 
					page_size: pagination1.page_size,
					total_rows: pagination1.total_rows
				},
		    pickerOptions1: {
		      disabledDate(time) {
		        return time.getTime() > Date.now(); // - 8.64e7 减去就是不包含今天的
			  	},
					shortcuts: [
						{
							text: '今天',
							onClick(picker) {
								picker.$emit('pick', new Date());
							}
						},{
							text: '昨天',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24);
								picker.$emit('pick', date);
							}
						},{
							text: '一周前',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit('pick', date);
							}
						}
					]
				}
		  }
		},
		created() {
			this.init();
		},
		methods: {
		  //初始化请求
		  init() {
		    this.querycustom();
		  },
		  getStatus(option) {
			  this.formdata.status = option;
		  },
		  // 查询
		  querycustom() {
		    if (this.timeData && this.timeData.length > 0) {
		      this.formdata.start_time = this.timeData[0]
					this.formdata.end_time = this.timeData[1]
				} else {
					this.formdata.start_time = ""
					this.formdata.end_time = ""
				}
				this.axios
					.post(api.withdrawRecord, this.formdata)
					.then(response => {
						if (response.data.code == 0) {
							this.tableData = response.data.result
							this.page = response.data.page
						} 
					}).catch(error => {});
		  },
		  searchcustomer() {
		    this.formdata.page = 1
		    this.querycustom()
		  },
		  pageIndexChange(pageindex) {
		    this.formdata.page = pageindex;
		    this.querycustom();
		  }
		}
	}
</script>
